module.exports = __webpack_public_path__ + "static/media/select-arrow.5a679ce3.svg";